// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24PP3","toggle":"styles_toggle__3BQVI","preview":"styles_preview__2Kgvf"};